var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-tips"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('common.title')))]),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.$t('common.mobileTips')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/images/menu/logo.svg")}})])
}]

export { render, staticRenderFns }